var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1172 3.04688C11.0078 2.9375 10.8438 2.9375 10.7344 3.04688L4.77344 9.00781L4.5 11.5508C4.44531 11.8789 4.74609 12.1797 5.07422 12.125L7.61719 11.8516L13.5781 5.89062C13.6875 5.78125 13.6875 5.61719 13.5781 5.50781L11.1172 3.04688ZM15.5469 2.41797L14.207 1.07812C13.7969 0.667969 13.1133 0.667969 12.7031 1.07812L11.7461 2.03516C11.6367 2.14453 11.6367 2.30859 11.7461 2.41797L14.207 4.87891C14.3164 4.98828 14.4805 4.98828 14.5898 4.87891L15.5469 3.92188C15.957 3.51172 15.957 2.82812 15.5469 2.41797ZM10.625 10.2383V13H1.875V4.25H8.13672C8.24609 4.25 8.32812 4.22266 8.38281 4.16797L9.47656 3.07422C9.66797 2.85547 9.53125 2.5 9.23047 2.5H1.4375C0.699219 2.5 0.125 3.10156 0.125 3.8125V13.4375C0.125 14.1758 0.699219 14.75 1.4375 14.75H11.0625C11.7734 14.75 12.375 14.1758 12.375 13.4375V9.14453C12.375 8.84375 12.0195 8.70703 11.8008 8.89844L10.707 9.99219C10.6523 10.0469 10.625 10.1289 10.625 10.2383Z",
    fill: "#025652"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/EditIcon.d55d2800.svg";
export { ForwardRef as ReactComponent };